import { ModelBase } from '../../shared/base/model-base';
import { ObjectObservable } from '../../shared/base/object-observable';
import { User } from '../../users/shared/user';
import {SyllabusCurriculum} from "./syllabus-curriculum";
import {CurriculumUnit} from "./curriculum-unit";
import {NumberingListItem} from "./numbering-list-item";
import {Recommender} from "./recommender";

export class Syllabus extends ModelBase {

  owner?: string;
  mainTitleBackgroundImg?: string;
  subTitle?: string;
  purpose?: string;

  advantageTitle?: string;
  advantage1Img?: string;
  advantage1Title?: string;
  advantage1Exp?: string;

  advantage2Img?: string;
  advantage2Title?: string;
  advantage2Exp?: string;

  advantage3Img?: string;
  advantage3Title?: string;
  advantage3Exp?: string;

  additionalTitle?: string;
  addCard1Title?: string;
  addCard1Exp?: string;
  addCard2Title?: string;
  addCard2Exp?: string;
  addCard3Title?: string;
  addCard3Exp?: string;

  instructorMsgTitle?: string;
  instructorName?: string;
  instructorPos?: string;
  instructorMsg?: string;

  curriculum?: CurriculumUnit[];
  numberingList?: NumberingListItem[];
  recommenders?: Recommender[];
  applyCard: string;
  applyUrl: string;

  hookMsg?: string;

}




// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/syllabuses/shared/syllabus.ts